// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animale-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 20px;
}
/* MOBILE */
@media (max-width: 480px) {
  .animale-page {
    padding: 5px;
  }
  .filtre-grid select {
    width: 135px;
  padding: 10px 14px;
  border: 1.5px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  outline: none;
}
@media (max-width: 480px) {
    .filtre-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
}

.animale-header {
  text-align: center;
  margin-bottom: 32px;
}

.animale-header h1 { font-size: 32px; margin-bottom: 8px; }
.animale-header p { color: #666; }

.filtre-container {
  background: #f9fafb;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
}

.filtre-container h3 { margin-bottom: 16px; }

.filtre-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  align-items: end;
}

/* MOBILE */
@media (max-width: 768px) {
  .filtre-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.filtre-grid select {
  padding: 10px 14px;
  border: 1.5px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  outline: none;
}

.filtre-grid select:focus { border-color: #fdb3fd; }

.filtre-butoane {
  display: flex;
  gap: 8px;
}

.btn-cauta {
  flex: 1 1;
  padding: 10px;
  background: #f2c94c;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}

.btn-reset {
  padding: 10px 16px;
  background: #f3f4f6;
  color: #666;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.anunturi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.anunt-card-public {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  border: 1.5px solid #eee;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: transform 0.2s, box-shadow 0.2s;
}

.anunt-card-public:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}

.card-imagine img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.no-image-placeholder {
  width: 100%;
  height: 200px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
}

.card-info { padding: 16px; }

.card-titlu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.card-titlu strong { font-size: 16px; }
.card-data { font-size: 12px; color: #999; }

.card-detalii {
  display: flex;
  gap: 12px;
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.card-descriere {
  font-size: 13px;
  color: #444;
  line-height: 1.5;
  margin: 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-contact {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.card-contact a {
  font-size: 15px;
  color: black;
  text-decoration: none;
  font-weight: 500;
}

.card-contact a:hover { text-decoration: underline; }

.loading-text, .no-results {
  text-align: center;
  padding: 60px;
  color: #666;
}
/* Card — cursor pointer + badge număr poze */
.anunt-card-public { cursor: pointer; }
.anunt-card-public:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.12); }

.card-poza-count {
  position: absolute;
  bottom: 8px; right: 8px;
  background: rgba(0,0,0,0.6);
  color: white;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.card-imagine { position: relative; }

/* Modal overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.modal-anunt {
  background: white;
  border-radius: 20px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  animation: slideUp 0.25s ease;
}

.modal-inchide {
  position: absolute;
  top: 14px; right: 14px;
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 34px; height: 34px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-size: 14px;
}
.modal-inchide:hover { background: rgba(0,0,0,0.8); }

/* Galerie */
.modal-galerie {
  position: relative;
  background: #000;
  border-radius: 20px 0 0 20px;
  overflow: hidden;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.modal-poza-principala {
  width: 100%;
  flex: 1 1;
  object-fit: cover;
  max-height: 420px;
}

.modal-no-image {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.btn-poza-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255,255,255,0.9);
  border: none;
  border-radius: 50%;
  width: 36px; height: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 5;
}
.btn-poza-nav.prev { left: 10px; }
.btn-poza-nav.next { right: 10px; }
.btn-poza-nav:hover { background: white; }

.modal-thumbnails {
  display: flex;
  gap: 6px;
  padding: 8px;
  background: rgba(0,0,0,0.7);
  overflow-x: auto;
}

.thumbnail {
  width: 56px; height: 48px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  opacity: 0.6;
  border: 2px solid transparent;
  flex-shrink: 0;
}
.thumbnail.activ {
  opacity: 1;
  border-color: #f97316;
}

.modal-poza-index {
  text-align: center;
  color: rgba(255,255,255,0.8);
  font-size: 12px;
  padding: 4px;
  background: rgba(0,0,0,0.6);
}

/* Detalii modal */
.modal-detalii {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

.modal-titlu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-titlu h2 { font-size: 22px; margin: 0; }

.badge-tip {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}
.badge-tip.gasit { background: #dcfce7; color: #16a34a; }
.badge-tip.pierdut { background: #fee2e2; color: #dc2626; }

.modal-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.modal-info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.modal-descriere {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.modal-descriere p {
  margin: 0;
  color: #444;
  font-size: 14px;
  line-height: 1.6;
  background: #f9fafb;
  padding: 12px;
  border-radius: 10px;
}

.modal-contact {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: 1.5px solid #eee;
  padding-top: 16px;
}
.modal-contact h4 { margin: 0; font-size: 15px; }

.contact-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}
.contact-btn:first-of-type {
  background: #dcfce7;
  color: #16a34a;
}
.contact-btn:last-of-type {
  background: #eff6ff;
  color: #2563eb;
}
.contact-btn:hover { opacity: 0.85; }

@media (max-width: 700px) {
  .modal-anunt { grid-template-columns: 1fr; }
  .modal-galerie { border-radius: 20px 20px 0 0; }
  .modal-poza-principala { max-height: 280px; }
}
.card-promovat-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: linear-gradient(135deg, #f59e0b, #f97316);
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/pages/AnimaleGasite.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA,WAAW;AACX;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;AACA;IACI;QACI,qCAAqC;IACzC;AACJ;AACA;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;AAC1D,oBAAoB,WAAW,EAAE;;AAEjC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA,4BAA4B,qBAAqB,EAAE;;AAEnD;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,aAAa,aAAa,EAAE;;AAE5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB,eAAe,EAAE;AACtC,aAAa,eAAe,EAAE,WAAW,EAAE;;AAE3C;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wBAAwB,0BAA0B,EAAE;;AAEpD;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA,6CAA6C;AAC7C,qBAAqB,eAAe,EAAE;AACtC,2BAA2B,2BAA2B,EAAE,uCAAuC,EAAE;;AAEjG;EACE,kBAAkB;EAClB,WAAW,EAAE,UAAU;EACvB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,gBAAgB,kBAAkB,EAAE;;AAEpC,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA,uBAAuB,2BAA2B,EAAE;;AAEpD,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;AACA,qBAAqB,UAAU,EAAE;AACjC,qBAAqB,WAAW,EAAE;AAClC,sBAAsB,iBAAiB,EAAE;;AAEzC;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,kBAAkB,eAAe,EAAE,SAAS,EAAE;;AAE9C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;AACnB;AACA,oBAAoB,SAAS,EAAE,eAAe,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,qBAAqB,aAAa,EAAE;;AAEpC;EACE,eAAe,0BAA0B,EAAE;EAC3C,iBAAiB,4BAA4B,EAAE;EAC/C,yBAAyB,iBAAiB,EAAE;AAC9C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".animale-page {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n/* MOBILE */\n@media (max-width: 480px) {\n  .animale-page {\n    padding: 5px;\n  }\n  .filtre-grid select {\n    width: 135px;\n  padding: 10px 14px;\n  border: 1.5px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  outline: none;\n}\n@media (max-width: 480px) {\n    .filtre-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n}\n\n.animale-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.animale-header h1 { font-size: 32px; margin-bottom: 8px; }\n.animale-header p { color: #666; }\n\n.filtre-container {\n  background: #f9fafb;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 32px;\n}\n\n.filtre-container h3 { margin-bottom: 16px; }\n\n.filtre-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n  align-items: end;\n}\n\n/* MOBILE */\n@media (max-width: 768px) {\n  .filtre-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n.filtre-grid select {\n  padding: 10px 14px;\n  border: 1.5px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  outline: none;\n}\n\n.filtre-grid select:focus { border-color: #fdb3fd; }\n\n.filtre-butoane {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-cauta {\n  flex: 1;\n  padding: 10px;\n  background: #f2c94c;\n  color: rgb(0, 0, 0);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.btn-reset {\n  padding: 10px 16px;\n  background: #f3f4f6;\n  color: #666;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.anunturi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n.anunt-card-public {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1.5px solid #eee;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.06);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.anunt-card-public:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.1);\n}\n\n.card-imagine img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.no-image-placeholder {\n  width: 100%;\n  height: 200px;\n  background: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n}\n\n.card-info { padding: 16px; }\n\n.card-titlu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.card-titlu strong { font-size: 16px; }\n.card-data { font-size: 12px; color: #999; }\n\n.card-detalii {\n  display: flex;\n  gap: 12px;\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.card-descriere {\n  font-size: 13px;\n  color: #444;\n  line-height: 1.5;\n  margin: 8px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.card-contact {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.card-contact a {\n  font-size: 15px;\n  color: black;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.card-contact a:hover { text-decoration: underline; }\n\n.loading-text, .no-results {\n  text-align: center;\n  padding: 60px;\n  color: #666;\n}\n/* Card — cursor pointer + badge număr poze */\n.anunt-card-public { cursor: pointer; }\n.anunt-card-public:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.12); }\n\n.card-poza-count {\n  position: absolute;\n  bottom: 8px; right: 8px;\n  background: rgba(0,0,0,0.6);\n  color: white;\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n.card-imagine { position: relative; }\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n.modal-anunt {\n  background: white;\n  border-radius: 20px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  position: relative;\n  animation: slideUp 0.25s ease;\n}\n\n.modal-inchide {\n  position: absolute;\n  top: 14px; right: 14px;\n  background: rgba(0,0,0,0.5);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 34px; height: 34px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  font-size: 14px;\n}\n.modal-inchide:hover { background: rgba(0,0,0,0.8); }\n\n/* Galerie */\n.modal-galerie {\n  position: relative;\n  background: #000;\n  border-radius: 20px 0 0 20px;\n  overflow: hidden;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-poza-principala {\n  width: 100%;\n  flex: 1;\n  object-fit: cover;\n  max-height: 420px;\n}\n\n.modal-no-image {\n  width: 100%;\n  height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n}\n\n.btn-poza-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255,255,255,0.9);\n  border: none;\n  border-radius: 50%;\n  width: 36px; height: 36px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  z-index: 5;\n}\n.btn-poza-nav.prev { left: 10px; }\n.btn-poza-nav.next { right: 10px; }\n.btn-poza-nav:hover { background: white; }\n\n.modal-thumbnails {\n  display: flex;\n  gap: 6px;\n  padding: 8px;\n  background: rgba(0,0,0,0.7);\n  overflow-x: auto;\n}\n\n.thumbnail {\n  width: 56px; height: 48px;\n  object-fit: cover;\n  border-radius: 6px;\n  cursor: pointer;\n  opacity: 0.6;\n  border: 2px solid transparent;\n  flex-shrink: 0;\n}\n.thumbnail.activ {\n  opacity: 1;\n  border-color: #f97316;\n}\n\n.modal-poza-index {\n  text-align: center;\n  color: rgba(255,255,255,0.8);\n  font-size: 12px;\n  padding: 4px;\n  background: rgba(0,0,0,0.6);\n}\n\n/* Detalii modal */\n.modal-detalii {\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n}\n\n.modal-titlu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-titlu h2 { font-size: 22px; margin: 0; }\n\n.badge-tip {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.badge-tip.gasit { background: #dcfce7; color: #16a34a; }\n.badge-tip.pierdut { background: #fee2e2; color: #dc2626; }\n\n.modal-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.modal-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.modal-descriere {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.modal-descriere p {\n  margin: 0;\n  color: #444;\n  font-size: 14px;\n  line-height: 1.6;\n  background: #f9fafb;\n  padding: 12px;\n  border-radius: 10px;\n}\n\n.modal-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-top: 1.5px solid #eee;\n  padding-top: 16px;\n}\n.modal-contact h4 { margin: 0; font-size: 15px; }\n\n.contact-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 18px;\n  border-radius: 10px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n}\n.contact-btn:first-of-type {\n  background: #dcfce7;\n  color: #16a34a;\n}\n.contact-btn:last-of-type {\n  background: #eff6ff;\n  color: #2563eb;\n}\n.contact-btn:hover { opacity: 0.85; }\n\n@media (max-width: 700px) {\n  .modal-anunt { grid-template-columns: 1fr; }\n  .modal-galerie { border-radius: 20px 20px 0 0; }\n  .modal-poza-principala { max-height: 280px; }\n}\n.card-promovat-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: linear-gradient(135deg, #f59e0b, #f97316);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
